export const SliderItem = {
	name: 'SliderItem',
	props: {
		perPage: {
			type: Number,
			default: 4,
		}
	},
	render(h) {
		if (!this.$slots.default) { return; }

		let slots = this.$slots.default.filter(slot => slot.tag);

		let slides = [];
		let pages = slots.reduce((pages, slot, index) => {
			//Add Slots to Array of Slides
			slides.push(h('div', { class: 'slider__item', style: { width: `calc(100% / ${this.perPage})` } }, [slot]));

			//If hit number of per page or is last slots
			if (slides.length == this.perPage || (slots.length - 1) == index) {
				//Add Slides to Array Pages
				pages.push(h('div', { class: ['slide'] }, slides));
				//Rest Array of Slides
				slides = [];
			}

			//Return Pages
			return pages
		}, []);

		if (pages.length == 1) {
			pages[0].data.style = { 'justify-content': 'center' };
		}

		this.$parent.$emit('update-data', pages.length, 1);

		return h('div', { class: ['slide__wrapper'] }, [pages]);
	}
}
